import { useState } from "react";
import { motion } from "framer-motion";
import { Disc3, Cog, Crosshair, Layers, ArrowUpRight } from "lucide-react";
import { IMAGES } from "../lib/images";
import { Reveal } from "./Reveal";

const services = [
  { key: "tornitura", title: "Tornitura", icon: Disc3, desc: "Torni CNC ad alta precisione per particolari cilindrici e assialsimmetrici, piccola e media serie.", img: IMAGES.lathe, span: "md:col-span-8" },
  { key: "fresatura", title: "Fresatura 5 Assi", icon: Cog, desc: "Centri di lavoro a 5 assi per geometrie complesse e componenti critici.", img: IMAGES.milling, span: "md:col-span-4" },
  { key: "rettifica", title: "Rettifica", icon: Crosshair, desc: "Finiture superficiali e tolleranze micrometriche per superfici perfette.", img: "https://images.unsplash.com/photo-1602223114290-ba6de2938acc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", span: "md:col-span-4" },
  { key: "prototyping", title: "Rapid Prototyping", icon: Layers, desc: "Stampa 3D e prototipazione rapida: dalla tua idea al pezzo funzionante in tempi brevi.", img: IMAGES.factory, span: "md:col-span-8" },
];

const Card = ({ s, hovered, setHovered }) => {
  const Icon = s.icon;
  const dim = hovered && hovered !== s.key;
  return (
    <motion.div
      data-testid={`service-${s.key}`}
      onMouseEnter={() => setHovered(s.key)}
      onMouseLeave={() => setHovered(null)}
      animate={{ opacity: dim ? 0.4 : 1 }}
      transition={{ duration: 0.4 }}
      className={`group relative border border-white/10 overflow-hidden min-h-[320px] md:min-h-[420px] flex flex-col justify-end ${s.span}`}
    >
      <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700 ease-out" />
      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/50 to-transparent" />
      <div className="absolute top-6 left-6 z-10 text-red-600">
        <Icon size={28} strokeWidth={1.5} />
      </div>
      <ArrowUpRight className="absolute top-6 right-6 z-10 text-white/40 group-hover:text-red-600 group-hover:rotate-45 transition-all duration-500" />
      <div className="relative z-10 p-6 md:p-8">
        <h3 className="font-display font-bold text-3xl md:text-4xl tracking-tight mb-3">{s.title}</h3>
        <p className="text-zinc-300 max-w-md leading-relaxed">{s.desc}</p>
      </div>
    </motion.div>
  );
};

export const Services = () => {
  const [hovered, setHovered] = useState(null);
  return (
    <section id="lavorazioni" data-testid="services" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-red-600" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Lavorazioni</span>
            </div>
            <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none">
              Cosa<br />realizziamo
            </h2>
          </div>
          <p className="max-w-sm text-zinc-400 leading-relaxed">
            Elevati standard di precisione e qualità per soddisfare ogni esigenza produttiva, dalla progettazione al collaudo finale.
          </p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {services.map((s) => (
          <Card key={s.key} s={s} hovered={hovered} setHovered={setHovered} />
        ))}
      </div>
    </section>
  );
};
